const getters = {
    isLogin:state=>state.app.isLogin,
    isVip:state=>state.app.isVip,
    userinfo:state=>state.user.userinfo,
    batchValue:state=>state.app.batchValue,
    navSelect:state=>state.app.navSelect,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js